var chunkToChildrenMap = {
	"editDonation": [
		"src_products_components_Product_ProductPagination_vue"
	],
	"createProduct": [
		"vendors",
		"src_orders_components_OrderCreation_ProductsStep_ProductSelection_ProductsModal_ProductOption-32893f",
		"src_orders_store_draft_products_module_ts-src_products_components_Product_GroupedProduct_AddG-483b3f",
		"src_products_components_Product_ProductPagination_vue",
		"src_products_components_Product_ProductOptions_vue"
	],
	"optionsLibrary": [
		"src_products_components_Options_OptionsCreateForm_vue",
		"src_common_composables_use-locale_ts-src_common_helpers_user_has-ai-feature-flag_ts-src_produ-373b16",
		"src_products_components_Options_OptionsTable_vue",
		"src_products_components_Options_OptionsEmpty_vue"
	],
	"productOption": [
		"src_products_components_Options_OptionsCreateForm_vue",
		"src_common_composables_use-user_ts-src_common_helpers_user_has-ai-feature-flag_ts-src_product-207d62"
	],
	"editProduct": [
		"vendors",
		"src_orders_components_OrderCreation_ProductsStep_ProductSelection_ProductsModal_ProductOption-32893f",
		"src_orders_store_draft_products_module_ts-src_products_components_Product_GroupedProduct_AddG-483b3f",
		"src_products_components_Product_ProductPagination_vue",
		"src_products_components_Product_ProductOptions_vue"
	],
	"src_donations_components_AdditionalDetailsBody_vue": [
		"src_donations_components_DonationFiltrationSelectPresetModal_vue",
		"src_products_components_Product_ProductFiltrationSelectPresetModal_vue"
	],
	"src_products_components_Product_AdditionalDetailsBody_vue": [
		"src_products_components_Product_ProductFiltrationSelectPresetModal_vue"
	],
	"src_donations_components_DonationCustomFieldItem_vue": [
		"src_donations_components_DonationCustomFieldForm_vue"
	],
	"src_products_components_Product_ProductOptionsBody_vue": [
		"src_products_components_Options_OptionsCreateForm_vue",
		"src_common_composables_use-user_ts-src_common_helpers_user_has-ai-feature-flag_ts-src_product-207d62",
		"src_products_components_Product_ProductOptionsVariantsImageSelectorModal_vue",
		"src_products_components_Product_ProductVariantStocksModal_vue"
	],
	"src_products_components_Product_DigitalProductMultipleVariants_DigitalProductMultipleVariants_vue": [
		"src_products_components_Options_OptionsCreateForm_vue",
		"src_common_composables_use-user_ts-src_common_helpers_user_has-ai-feature-flag_ts-src_product-207d62",
		"src_products_components_Product_ProductOptionsVariantsImageSelectorModal_vue",
		"src_products_components_Product_ProductVariantStocksModal_vue"
	],
	"src_products_components_Product_ProductCustomFieldItem_vue": [
		"src_products_components_Product_ProductCustomFieldForm_vue"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };